import { jsx as _jsx } from "react/jsx-runtime";
import { memo, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { PANEL_WIDTH, PickerTypes } from '../constants';
import { logDebug } from './utils';
const PanelIframe = /*#__PURE__*/forwardRef(({
  fullScreen,
  iframeUrl,
  logBreadcrumb,
  panelWidth = PANEL_WIDTH,
  pickerType
}, ref) => {
  const width = fullScreen || pickerType === PickerTypes.SIDE_MODAL ? '100%' : panelWidth;
  return /*#__PURE__*/_jsx("iframe", {
    ref: ref,
    src: iframeUrl,
    scrolling: "no",
    style: {
      position: 'fixed',
      top: 0,
      right: 0,
      width,
      height: '100%',
      border: '0 none',
      pointerEvents: 'initial'
    },
    "data-test-id": "file-manager-panel-iframe",
    onLoad: () => {
      logDebug('iframe onLoad fired');
      logBreadcrumb('iframe onLoad fired');
    }
  });
});
PanelIframe.displayName = 'PanelIframe';
PanelIframe.propTypes = {
  iframeUrl: PropTypes.string.isRequired
};
export default /*#__PURE__*/memo(PanelIframe);